/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISiloRepository0612Like,
  ISiloRepository0612LikeInterface,
} from "../ISiloRepository0612Like";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getSilo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISiloRepository0612Like__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloRepository0612LikeInterface {
    return new utils.Interface(_abi) as ISiloRepository0612LikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloRepository0612Like {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ISiloRepository0612Like;
  }
}
